"use strict";
// Avoid exporting constants as it allows to change definition without making breaking changes
// We should only use functions to access their definitions
// That also avoid leaking legal forms mapping logic out of this library
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_FORMS = void 0;
var constants_1 = require("./constants");
Object.defineProperty(exports, "LEGAL_FORMS", { enumerable: true, get: function () { return constants_1.LEGAL_FORMS; } });
__exportStar(require("./helpers"), exports);
